<template>
<div >

<div class="modal" id="printZebraModal" tabindex="-1">
  <div class="modal-dialog modal-lg  " >
    <div class="modal-content">
      <div class="modal-header border-primary">
        <h5 style="color:white" class="modal-title">
          
           <i  class="fa fa-print mr-2" aria-hidden="true"></i>
          STAMPA ETICHETTE ( ZebraBrowserPrint )
        
        </h5>
         <button style="color:white" type="button" @click="$emit('close')" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        
        <!--
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
         --> 
      </div>
      <div class="modal-body">
          
          <div class="row">
            <div class="col-6">
            <strong>Lista stampanti </strong>
            <select  class="form-control mb-2" id="selected_device_" @change="onDeviceSelected(device_uid)" v-model="device_uid">
              <option v-for="(item,index) in devices" :value="item.uid" :key="index">{{item.name}}</option>       
            </select>

            <strong>Formato etichetta</strong>
            <select  class="form-control" id="label"  v-model="labelId">
              <option v-for="(item,index) in labels" :value="item.label_Id" :key="index">{{item.description}}</option>       
            </select>

          <!--  
          <div class="form-check mt-2 mb-2">
            <input class="form-check-input" type="checkbox" id="defaultCheck1" v-model="promoCheck">
            <label class="form-check-label" for="defaultCheck1">
              Stampa etichetta <strong>PROMO</strong>
            </label>
          </div>
          -->  

            <button @click="printToSelectedPrinter()" type="button" class="btn btn-primary mt-4">
              <i  class="fa fa-print mr-2" aria-hidden="true"></i>
              STAMPA ETICHETTE
              <span class="badge badge-light ml-2 mr-2">{{labelCount}}</span>
            </button> 

            <!--
            <button type="button"  class="btn btn-primary mt-2" @click="writeToSelectedPrinterTest('~hs'), readFromSelectedPrinter()">
              Test 
            </button>  
            -->

        </div>
        </div>

        <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

      </div>

      <!--
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
        
      </div>
      -->
    </div>
  </div>
</div>

</div>
</template>
<script>
import alertBox          from '@/components/common/AlertBox.vue'
import api               from '@/api'          
import { mapGetters }    from 'vuex';


export default {
  components  : {alertBox},
  props: ['data'],
  data () {
    return {
        
     
      labels      : [],
      labelId     : 1,
      zpl         : {},
      device_list : [],
      selected_device : {},
      devices : [],
      device_uid : '',
     
      FS         : '^FS',
      SF         : '^XA^CI0,21,36',
      qty        : '^PQ',
      EF         : '^XZ',

      msg        : {
          title : ''
       
      },
      
      labelCount      : 0,
     

    }
  },
  computed: 
  {
     ...mapGetters(['company']),
  },
  mounted()
    {
      
    },
    
 created()
  {
    this.data.forEach(item=>
    {
      this.labelCount += item.qty
    })
    this.getLabelList()
    this.setup()
       
  },  
  methods: 
    {
    fmt(value)
    { 
      if(!isNaN(value))
      {
      return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: 2 ,maximumFractionDigits: 2});
      }
    },

    async getLabelList()
    {
      let sp = {'sp'          : 'spCompanyLabels'}
      let data = {'companyId' : this.company.Id}
      let  json = Object.assign(data, sp);
      
      this.labels = []
      await api.post(json).then(res => {
        
        if(res.status==200)
          {
            
            this.labels = res.data.recordsets[1]
            this.fd_key = res.data.recordsets[0]
            this.labelId = res.data.recordsets[1][0].label_Id
          }
          else if(res.status==500)
          {
            

            
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res.data
            this.msg.type = 1


          } 
          else
          {
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type = 1
               
          } 
      }).catch(err => 
      {
      
        this.msg.title = 'ATTENZIONE '
        this.msg.body = err.message
        this.msg.type = 1

      }).finally(() => {
        this.spinner = false
      });
    },
    setup()
    {
      
	  //Get the default device from the application as a first step. Discovery takes longer to complete.
    
    var _this = this
    
    BrowserPrint.getDefaultDevice("printer", function(device)
			{
                
                //alert("Devices: " + JSON.stringify(device)) 
                //Add device to list of devices and to html select element
                
				_this.selected_device =  JSON.stringify(device)
                _this.devices.push(device);
                
                _this.device_uid = _this.devices[0].uid
                _this.onDeviceSelected(_this.devices[0].uid)

                
                

				//Discover any other devices available to the application
      
      BrowserPrint.getLocalDevices(function(device_list){

					for(var i = 0; i < device_list.length; i++)
					{
            //Add device to list of devices and to html select element
            /*
						var device = device_list[i];
						if(!_this.selected_device || device.uid != _this.selected_device.uid)
						{
              //_this.devices.push(device);
            }
            */

          }
          
					
				}, () => {
          
         
          this.msg.title = 'ATTENZIONE '
          this.msg.type = 1
          this.msg.body = 'Errore rilevamento stampante.'
          
          },"printer");
				
			}, (err) =>{
        let msg = err ? err : 'Zebra Browser Print non avviato.'
        
        this.msg.title = 'ATTENZIONE '
        this.msg.body = msg
        this.msg.type = 1
          
				
      })
      


},
 getConfig(){
	BrowserPrint.getApplicationConfiguration(function(config){
		alert(JSON.stringify(config))
	}, function(error){
		alert(JSON.stringify(new BrowserPrint.ApplicationConfiguration()));
	})
},
writeToSelectedPrinterReset(dataToWrite)
{
  
    this.selected_device.send(dataToWrite, undefined, this.errorCallback);
},
printToSelectedPrinter()
{
    this.msg.title = ''
    
    if(this.labelCount== 0)
    {
       
        this.msg.title = 'ATTENZIONE '
        this.msg.type = 1
        this.msg.body = 'Numero etichette da stampare non valido.'
        return
    }
    var dataToWrite = ''
   
    this.zpl = this.fd_key.filter(item=>item.label_Id == this.labelId)
        
        this.data.forEach(d => {
          dataToWrite += this.SF
          this.zpl.forEach(item =>{
            
            let zpl   = item['zpl']
            let skip  = item['skip']
            let fmt   = item['fmt']
            let blank = item['blank'] > 0 ? " " : ""
            let len   = item['fd_len']
           

            // ONLY ZPL
            if(skip==1)
            {
              
             dataToWrite += zpl + blank + this.FS 
            }  
            else
            {
              // FORMAT PRICE
              if(fmt==1)
              {
                dataToWrite += zpl + blank  + this.fmt(d[item['fd_key']]) + this.FS 
              }
              else
              {
                if(len > 0)
                {
                  dataToWrite += zpl + blank + d[item['fd_key']].substr(0, len) + this.FS   
                }
                else
                {
                  dataToWrite += zpl + blank + d[item['fd_key']] + this.FS   
                }
                
              }

            }
            
            
            
            })   
            
            //const logo = '^FO250,110^GFA,774,774,18,,:::::::O01EJ03F,N01FEI01FFC,N07FCI0603F,M01E08K02F8,M03N0638,M06J06I0C1CK0C,M0CJ0EI0C1CJ01C,M0F7C00C00180C1K01,M03FFC1800180C38640C78,M01FFE3E00180868CE18E,O01E3C003018D0DE38E,P0C3I03010D1EC30E,P0C7I03021E1CC30F,O0307I070C1E1CC707,L0101E07C407F01E99C7D6,M03F8038E03800F108336,L01FCJ0CP038,L01E,,::::::::::::::::' + this.FS
            //dataToWrite += logo
            dataToWrite += this.qty + d.qty
            dataToWrite += this.EF
            
         
        })
    

    if(this.device_uid=='')
    {
       
        
        this.msg.title = 'ATTENZIONE '
        this.msg.type = 1
        this.msg.body = 'Selezionare una stampante.'
        return
    }
    
    this.msg.title = ''
    //this.writeToSelectedPrinterTest('~hs')
    this.selected_device.send(dataToWrite, undefined, this.errorCallback);
    
},
readCallback (readData) {
	if(readData === undefined || readData === null || readData === "")
	{
    

    this.msg.title = 'ATTENZIONE '
    this.msg.type = 1
    this.msg.body = 'Nessuna risposta dalla stampante.'
		//alert("No Response from Device");
	}
	else
	{
    

    this.msg.title = 'ATTENZIONE '
    this.msg.type = 1
    this.msg.body = readData
		
	
	}
	
},
errorCallback (errorMessage){
	
    

    this.msg.title = 'ATTENZIONE '
    this.msg.type = 1
    this.msg.body = errorMessage
  
    

},
readFromSelectedPrinter()
{

	this.selected_device.read(this.readCallback, this.errorCallback);
	
},
getDeviceCallback(deviceList)
{
    
	alert("Devices: \n" + JSON.stringify(deviceList, null, 4))
},

sendImage(imageUrl)
{
	url = window.location.href.substring(0, window.location.href.lastIndexOf("/"));
	url = url + "/" + imageUrl;
	selected_device.convertAndSendFile(url, undefined, errorCallback)
},
sendFile(fileUrl){
    url = window.location.href.substring(0, window.location.href.lastIndexOf("/"));
    url = url + "/" + fileUrl;
    selected_device.sendFile(url, undefined, errorCallback)
},

onDeviceSelected(selected)
{
   
  this.msg.title = ''
	for(var i = 0; i < this.devices.length; ++i){
		if(selected == this.devices[i].uid)
		{
			this.selected_device = this.devices[i];
      //this.writeToSelectedPrinterReset('~HS')
      //console.log('Reset')
			return;
		}
	}
  
  
},       



    }
  
}
</script>
<style scoped>
#modalPrintLabel 
.modal-footer {  
  justify-content: space-between;  
}
.modal-header
{
  background-color: rgb(11, 132, 165);
}
.form-check-label{
  cursor:pointer
}
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}

</style>

